// Suppress ResizeObserver errors in development
const suppressResizeObserverLoopError = () => {
  const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
  const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
  
  if (resizeObserverErrDiv && resizeObserverErr) {
    resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
  
  // Catch ResizeObserver errors
  window.addEventListener('error', (e) => {
    if (e.message.includes('ResizeObserver loop completed')) {
      e.stopImmediatePropagation();
    }
  });
};

export default suppressResizeObserverLoopError;